import {
  Sheet,
  SheetOverlay,
  SheetContent,
  SheetTitle,
  SheetBody,
} from '@wartek-id/sheet'
import { Icon } from '@wartek-id/icon'
import { Radio, RadioGroup } from '@wartek-id/radio'

type TopicFilterProps = {
  isOpen: boolean
  selected: string
  onClose: () => void
  onSelect: (value: string) => void
}

const STATE_FILTER = {
  recommendation: 'Rekomendasi',
  newest: 'Paling baru',
  oldest: 'Paling lama',
  'almost-done': 'Hampir selesai',
  'just-started': 'Baru mulai',
  title: 'Judul A-Z',
}

const TopicFilter = ({
  isOpen,
  selected,
  onClose,
  onSelect,
}: TopicFilterProps) => {
  return (
    <Sheet
      type="modal"
      isOpen={isOpen}
      autoFocus
      closeOnOverlayClick
      position="bottom"
      returnFocus
      onClose={onClose}
    >
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto">
        <SheetTitle className="flex items-center">
          <div className="mr-4" onClick={onClose}>
            <Icon>arrow_back</Icon>
          </div>
          <div className="flex-1 text-lg font-semibold">
            Urutkan topik berdasarkan
          </div>
        </SheetTitle>
        <SheetBody className="p-4">
          <RadioGroup
            name="filter"
            value={selected}
            className="flex-col"
            onChange={onSelect}
          >
            {Object.keys(STATE_FILTER).map((key) => (
              <Radio key={key} value={key} className="mb-2">
                {STATE_FILTER[key]}
              </Radio>
            ))}
          </RadioGroup>
        </SheetBody>
      </SheetContent>
    </Sheet>
  )
}

export default TopicFilter
